var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 40,
    viewBox: "0 0 65 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.6548 32.173V31.4019H63.454L63.2216 31.9311L62.9906 31.4019H62.7891V32.173H62.9318V31.5921L63.149 32.0933H63.2968L63.5141 31.5908V32.173H63.6554H63.6548ZM62.3807 32.173V31.5339H62.6378V31.4038H61.981V31.5339H62.238V32.173H62.3794H62.3807Z",
    fill: "#F79410"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8281 35.4805H23.4482V4.24658H40.8284L40.8281 35.4805Z",
    fill: "#FF5F00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5501 19.8641C24.5501 13.5283 27.5167 7.88433 32.1362 4.24712C28.6395 1.48989 24.3145 -0.00655806 19.8615 2.1605e-05C8.89203 2.1605e-05 0 8.89332 0 19.8641C0 30.8348 8.89203 39.7281 19.8615 39.7281C24.3147 39.7348 28.6397 38.2383 32.1366 35.481C27.5173 31.8445 24.5501 26.2002 24.5501 19.8641Z",
    fill: "#EB001B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2753 19.8641C64.2753 30.8348 55.3833 39.7281 44.4139 39.7281C39.9602 39.7347 35.6347 38.2383 32.1372 35.481C36.758 31.8438 39.7246 26.2002 39.7246 19.8641C39.7246 13.528 36.758 7.88433 32.1372 4.24713C35.6346 1.48997 39.96 -0.00644273 44.4135 2.08514e-05C55.383 2.08514e-05 64.275 8.89333 64.275 19.8641",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMastercard);
export default __webpack_public_path__ + "static/media/ic-mastercard.9cc6c807fafa96fb005ef7c0978b2e01.svg";
export { ForwardRef as ReactComponent };